import {
  HAS_DIGIT_PATTERN,
  HAS_LOWERCASE_CHARACTER_PATTERN,
  HAS_SPECIAL_CHARACTERS_PATTERN,
  HAS_UPPERCASE_CHARACTER_PATTERN,
} from 'app-constants'

export const PASSWORD_RULES = [
  {
    label: 'No mínimo 8 caracteres',
    test: ({ password }) => password.length >= 8,
  },
  {
    label: 'Pelo menos uma letra MAIÚSCULA',
    test: ({ password }) => HAS_UPPERCASE_CHARACTER_PATTERN.test(password),
  },
  {
    label: 'Pelo menos uma letra minúscula ',
    test: ({ password }) => HAS_LOWERCASE_CHARACTER_PATTERN.test(password),
  },
  {
    label: 'Pelo menos um número',
    test: ({ password }) => HAS_DIGIT_PATTERN.test(password),
  },
  {
    label: 'A senha não deve ser igual às anteriores',
    test: ({ password, currentPassword }) => password !== currentPassword,
  },
  {
    label: 'Sem espaços, sem caracteres especiais, sem emojis ou vírgulas',
    test: ({ password }) => !HAS_SPECIAL_CHARACTERS_PATTERN.test(password),
  },
  {
    label: 'As senhas coincidem',
    test: ({ password, confirmPassword }) => password === confirmPassword,
  },
]
